import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { RequestDetails, RequestService } from "../services/request.service";

@Injectable()
export class RequestDetailsResolver implements Resolve<RequestDetails> {
  constructor(private requestService: RequestService) {
  }
  resolve(route: ActivatedRouteSnapshot): Observable<RequestDetails> {
    const id: number = route.params['id'];
    return this.requestService.getDetails(id);
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/resolvers/request-details.resolver.ts